import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { IonicModule } from "@ionic/angular";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { EditEquipmentComponent } from "./edit-equipment.component";
import { LoadingStiModule } from "src/app/_component/loading-sti/loading-sti.module";
import { SelectDropdownModule } from "src/app/app/_component/select-dropdown/select-dropdown.module";
import { ModalHeaderComponentModule } from "src/app/app/_component/modal-header/modal-header.module";
import { InputsModule } from "src/app/_component/inputs/inputs.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    RouterModule,
    LoadingStiModule,
    ReactiveFormsModule,
    SelectDropdownModule,
    ModalHeaderComponentModule,
    InputsModule,
  ],

  declarations: [EditEquipmentComponent],
  exports: [EditEquipmentComponent],
})
export class EditEquipmentModule {}
